import { Postcode } from '@dreryk/address-common-api';
import { HealthcarePractice, MedicalChamber } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { EmailAddress } from '@dreryk/email-address-common-api';
import { HealthcareProviderRegisterBookNumber } from '@dreryk/healthcare-provider-register-book-number-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';
import { FileDescriptor } from '@dreryk/command-query-ws-api';

import { createFileDescriptorFromBase64 } from '@dreryk/react-common';

export type HealthcarePracticeFormBean = {
   registerBookNumber: HealthcareProviderRegisterBookNumber | null;
   medicalChamber: MedicalChamber | null;
   name: string | null;
   city: string | null;
   postcode: Postcode | null;
   street: string | null;
   house: string | null;
   flat: string | null;
   skipAddressInStamp: boolean;
   phoneNumber: PhoneNumber | null;
   emailAddress: EmailAddress | null;
   regon: string | null;
   taxIdentifier: string | null;
   logo: FileDescriptor | null;
};

export const mapHealthcarePracticeToBean = (healthcarePractice: HealthcarePractice): HealthcarePracticeFormBean => ({
   registerBookNumber: healthcarePractice.registerBookNumber ?? null,
   emailAddress: healthcarePractice.emailAddress ?? null,
   name: healthcarePractice.name ?? null,
   city: healthcarePractice.address.findTown()?.getName() ?? null,
   flat: healthcarePractice.address.findFlat()?.asString() ?? null,
   house: healthcarePractice.address.findBuilding()?.asString() ?? null,
   medicalChamber: healthcarePractice.medicalChamber ?? null,
   phoneNumber: healthcarePractice.phoneNumber ?? null,
   postcode: healthcarePractice.address.findPostcode() ?? null,
   regon: healthcarePractice.regon?.asString() ?? null,
   street: healthcarePractice.address.findStreet()?.asString() ?? null,
   taxIdentifier: healthcarePractice.taxIdentifier?.asString() ?? null,
   logo: healthcarePractice.logo
      ? createFileDescriptorFromBase64(
           healthcarePractice.logo.data,
           healthcarePractice.logo.fileName,
           healthcarePractice.logo.mimeType
        )
      : null,
   skipAddressInStamp: healthcarePractice.skipAddressInStamp,
});
